"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuiWalletWrapper = exports.Contract = void 0;
var cryptography_1 = require("@mysten/sui.js/cryptography");
var bn_js_1 = __importDefault(require("bn.js"));
var contractUtils_1 = require("../common/contractUtils");
var utils_1 = require("../common/utils");
var Contract = /** @class */ (function () {
    function Contract(stream, tokenId) {
        var meta = stream.meta.fields;
        var fees = stream.fees.fields;
        this.magic = 0;
        this.version = parseInt(stream.version);
        this.createdAt = parseInt(stream.created);
        this.withdrawnAmount = new bn_js_1.default(stream.withdrawn);
        this.canceledAt = parseInt(stream.canceled_at);
        this.end = parseInt(stream.end);
        this.lastWithdrawnAt = parseInt(stream.last_withdrawn_at);
        this.sender = stream.sender;
        this.senderTokens = stream.sender;
        this.recipient = stream.recipient;
        this.recipientTokens = stream.recipient;
        this.mint = tokenId;
        this.escrowTokens = "";
        this.streamflowTreasury = "";
        this.streamflowTreasuryTokens = "";
        this.streamflowFeeTotal = new bn_js_1.default(0);
        this.streamflowFeeWithdrawn = new bn_js_1.default(0);
        this.streamflowFeePercent = parseInt(fees.streamflow_fee_percentage) / 10000;
        this.partnerFeeTotal = new bn_js_1.default(0);
        this.partnerFeeWithdrawn = new bn_js_1.default(0);
        this.partnerFeePercent = parseInt(fees.partner_fee_percentage) / 10000;
        this.partner = stream.partner;
        this.partnerTokens = "";
        this.start = parseInt(stream.start);
        this.depositedAmount = new bn_js_1.default(stream.amount);
        this.period = parseInt(stream.period);
        this.amountPerPeriod = new bn_js_1.default(stream.amount_per_period);
        this.cliff = parseInt(stream.start);
        this.cliffAmount = new bn_js_1.default(stream.cliff_amount);
        this.cancelableBySender = meta.cancelable_by_sender;
        this.cancelableByRecipient = meta.cancelable_by_recipient;
        this.automaticWithdrawal = meta.automatic_withdrawal;
        this.transferableBySender = meta.transferable_by_sender;
        this.transferableByRecipient = meta.transferable_by_recipient;
        this.canTopup = meta.can_topup;
        var name = String.fromCharCode.apply(String, __spreadArray([], __read(meta.contract_name), false));
        this.name = Buffer.from(name, "hex").toString("utf8");
        this.withdrawalFrequency = parseInt(meta.withdrawal_frequency);
        this.closed = stream.closed;
        this.currentPauseStart = parseInt(stream.current_pause_start);
        this.pauseCumulative = new bn_js_1.default(stream.pause_cumulative);
        this.lastRateChangeTime = parseInt(stream.last_rate_change_time);
        this.fundsUnlockedAtLastRateChange = new bn_js_1.default(stream.funds_unlocked_at_last_rate_change);
        this.type = (0, contractUtils_1.buildStreamType)(this);
    }
    Contract.prototype.unlocked = function (currentTimestamp) {
        return (0, contractUtils_1.calculateUnlockedAmount)(__assign(__assign({}, this), { currentTimestamp: currentTimestamp }));
    };
    Contract.prototype.remaining = function (decimals) {
        return (0, utils_1.getNumberFromBN)(this.depositedAmount.sub(this.withdrawnAmount), decimals);
    };
    return Contract;
}());
exports.Contract = Contract;
var SuiWalletWrapper = /** @class */ (function () {
    function SuiWalletWrapper(wallet, client) {
        this.client = client;
        this.wallet = wallet;
        if (wallet instanceof cryptography_1.Keypair) {
            this.address = wallet.toSuiAddress();
        }
        else {
            this.address = wallet.address;
        }
    }
    SuiWalletWrapper.prototype.signAndExecuteTransactionBlock = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.wallet instanceof cryptography_1.Keypair) {
                    return [2 /*return*/, this.client.signAndExecuteTransactionBlock(__assign(__assign({}, input), { signer: this.wallet }))];
                }
                return [2 /*return*/, this.wallet.signAndExecuteTransactionBlock(input)];
            });
        });
    };
    return SuiWalletWrapper;
}());
exports.SuiWalletWrapper = SuiWalletWrapper;
